(() => {
  let overlayWidget;
  let overlayInitialized = false;
  const openOverlay = (initialState, transitionSource) => new Promise((resolve) => {
    initialState.startOpened = true;

    overlayWidget = window.swinger.widgets[overlayInitialized ? 'replace' : 'create']({
      type: 'rate-overlay',
      initialState,
    }, overlayWidget);

    if (!overlayInitialized) {
      (
        document.getElementById('swinger-append-container')
        || window.swinger.$('body', document)[0]
      ).appendChild(overlayWidget);
      overlayInitialized = true;
    } else {
      const overlay = overlayWidget.firstChild;
      window.swinger.overlayManager.open(overlay);
    }

    const callback = (e) => {
      const elem = e.detail.elem;

      if (elem && elem.matches('.swinger-overlay-rate-overlay')) {
        document.removeEventListener('swinger.overlay:open', callback);

        if (transitionSource) {
          transitionSource.style.viewTransitionName = '';
          transitionSource.style.pageTransitionTag = '';
        }

        resolve();
      }
    };

    document.addEventListener('swinger.overlay:open', callback);
  });

  window.swinger.eventHub.register('click keydown', '.swinger-button-rate', (e) => {
    if (!window.swinger.user.isLoggedIn()) {
      return;
    }

    if (e.type === 'keydown' && e.key !== ' ') {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e);
    const id = elem.getAttribute('data-id');
    const name = elem.getAttribute('data-name');

    window.swinger.$('.swinger-button-rate').forEach((elem) => { elem.removeAttribute('data-invoker'); });
    elem.setAttribute('data-invoker', '');

    openOverlay({
      id,
      name,
    }, elem);

    e.preventDefault();
  });

  window.swinger.observer.initialize('.swinger-button-rate', (elem) => {
    elem.setAttribute('role', 'button');
    elem.setAttribute('aria-controls', 'swinger-overlay-rate-overlay');
    elem.setAttribute('aria-expanded', 'false');
    elem.setAttribute('aria-haspopup', 'dialog');
  }, false);
})();
